export default __webpack_public_path__ + "static/media/other-main-down-arrow.f19f93db.svg";